import React from 'react';
import Modal from 'components/shared/Modal/Modal';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { Status } from 'common/utils/constants';

const WiFiTimersModal = (props) => {
  return (
    <Modal closeTargetRef={null} close={props.close} animate={false} animateX={false} opaque={true} height={436}>
      <div className="wifiTimersModal">
        <div className="wifiTimerModalHeader">
          <div className="wifiModalTitle">Timers</div>
        </div>

        <div className="wifiModalBody">
          <div className="wifiTimerSection">
            <div className="timerSectionHeader">
              <img src={IconLoader.icon_sandclock} alt="" />
              <span>Enabling Wi-Fi</span>
            </div>
            <div className="incrementer">
              <input
                className="incrementInput"
                onChange={(evt) => {
                  props.setWifiEnabledTimerValue(evt.target.value);
                }}
                value={props.wifiEnabledTimerValue}
                type="text"
              />
              <div className="incrementButtons">
                <div
                  onClick={() => {
                    props.setWifiEnabledTimerValue((value) => value + 1);
                  }}
                  className="increment"
                >
                  <SvgAF img={IconLoader.icon_add_time} hover={IconLoader.icon_add_time_hover} />
                </div>
                <div
                  className="decrement"
                  onClick={() => {
                    props.wifiEnabledTimerValue > 1 && props.setWifiEnabledTimerValue((value) => value - 1);
                  }}
                >
                  <SvgAF img={IconLoader.icon_subtract_time} hover={IconLoader.icon_subtract_time_hover} />
                </div>
              </div>
              <span className="metric">minutes</span>
            </div>
            <div className="enableTimerDescription">
              {'Pivot 5G will wait '}
              <span className="enableTimerVal">{props.wifiEnabledTimerValue}</span>
              {' minutes before enabling Wi-Fi if IBMS cannot be reached after reboot.'}
            </div>
          </div>
          <div className="wifiTimerSection">
            <div className="timerSectionHeader">
              <img src={IconLoader.icon_sandclock} alt="" />
              <span>Disabling Wi-Fi</span>
            </div>
            <div className="incrementer">
              <input
                className="incrementInput"
                onChange={(evt) => {
                  props.setWifiDisabledTimerValue(evt.target.value);
                }}
                value={props.wifiDisabledTimerValue}
                type="text"
              />
              <div className="incrementButtons">
                <div
                  onClick={() => {
                    props.setWifiDisabledTimerValue((value) => value + 1);
                  }}
                  className="increment"
                >
                  <SvgAF img={IconLoader.icon_add_time} hover={IconLoader.icon_add_time_hover} />
                </div>
                <div
                  className="decrement"
                  onClick={() => {
                    props.wifiDisabledTimerValue > 1 && props.setWifiDisabledTimerValue((value) => value - 1);
                  }}
                >
                  <SvgAF img={IconLoader.icon_subtract_time} hover={IconLoader.icon_subtract_time_hover} />
                </div>
              </div>
              <span className="metric">minutes</span>
            </div>
            <div className="disableTimerDescription">
              {'Once Wi-Fi is turned on, it will stay on for '}
              <span className="disableTimerVal">{props.wifiDisabledTimerValue}</span>
              {' minutes before being disabled.'}
            </div>
          </div>
        </div>

        <div className="wifiTimerModalFooter">
          {props.timersModalStatus !== Status.FAILURE && (
            <div className="wifiTimerModalConfirmSection">
              <button
                onClick={() => {
                  props.setIsWifiTimersModalOpen(false);
                  props.setAccessPointNameValue(null);
                  props.setAccessPointPasswordValue(null);
                }}
                className="Global_CancelButton wifiCancelButton"
              >
                Cancel
              </button>
              <button
                className="Global_ApplyButton wifiApplyButton"
                onClick={() => props.applyWifiTimers()}
                disabled={
                  isNaN(props.wifiEnabledTimerValue) ||
                  isNaN(props.wifiDisabledTimerValue) ||
                  props.wifiEnabledTimerValue < 1 ||
                  props.wifiDisabledTimerValue < 1
                }
              >
                {props.timersModalStatus === Status.NONE && 'Apply'}
                {props.timersModalStatus === Status.PENDING && (
                  <img alt="" className="Global_Spinner" src={IconLoader.icon_spinner_small} />
                )}
                {props.timersModalStatus === Status.SUCCESS && 'Applied'}
              </button>
            </div>
          )}

          {props.timersModalStatus === Status.FAILURE && (
            <div className="wifiModalErrorBox">
              <img src={IconLoader.icon_failed_medium} alt="" />
              <div className="wifiModalErrorMessageBlock">
                <span>{props.timersModalErrorMessage}</span>
              </div>
              <SvgAF
                onClick={() => {
                  props.setTimersModalStatus(Status.NONE);
                }}
                img={IconLoader.icon_close_mid}
                hover={IconLoader.icon_close_mid_hover}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default WiFiTimersModal;
